import Vue from "vue";
import moment from "moment";
import { googleApiKeys } from "../package.json";
import UseLang from "./services/Language";
import UploadService from "./services/UploadService";

const Compress = require("compress.js");
const uuidv4 = require("uuid/v4");

const globals = new Vue({
  name: "globals",
  computed: {
    currentUserRole() {
      if (this.currentUserInfo && this.currentUserInfo.UserTypeId)
        return this.currentUserInfo.UserTypeId;
      return -1;
    },
    currentUserName() {
      if (!this.currentUserInfo) return "";
      return (
        this.currentUserInfo.IsLoggedInAsUser ||
        this.currentUserInfo.LoginName ||
        ""
      );
    },
    permissions() {
      return (this.currentUserInfo && this.currentUserInfo.Permissions) || {};
    },
    currentDateFormatForInputMask() {
      let dateFormat = "yyyy-mm-dd";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "dd.mm.yyyy";
          break;
        case "fr":
        case "es":
          dateFormat = "dd/mm/yyyy";
          break;
        default:
          dateFormat = "yyyy-mm-dd";
      }
      return dateFormat;
    },
    currentDateFormatForMoment() {
      let dateFormat = "YYYY-MM-DD";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "DD.MM.YYYY";
          break;
        case "fr":
        case "es":
          dateFormat = "DD/MM/YYYY";
          break;
        default:
          dateFormat = "YYYY-MM-DD";
      }
      return dateFormat;
    },
    currentDateTimeFormatForMoment() {
      return this.currentDateFormatForMoment + " - HH:mm:ss";
    },
    currentLocale() {
      return this.selectedLanguage.substring(0, 2);
    },
    isAgencyUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.AgencyGuid;
    },
    isLeadAgencyUser() {
      return (
        !!this.currentUserInfo && this.currentUserInfo.AgencyTypeName === "Lead"
      );
    },
    isLocalAgencyUser() {
      return (
        !!this.currentUserInfo &&
        this.currentUserInfo.AgencyTypeName === "Local"
      );
    },
    isAudiUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.IsAudiUser;
    },
    isLoggedInAsOtherUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.IsLoggedInAsUser;
    },
    isIEBrowser() {
      var ua = window.navigator.userAgent;
      // IE 10 or older
      if (ua.indexOf("MSIE ") > 0) return true;
      // IE 11
      if (ua.indexOf("Trident/") > 0) return true;
      // Edge (IE 12+)
      if (ua.indexOf("Edge/") > 0) return true;
      // other browser
      return false;
    },
    googleApiKey() {
      if (_.includes(process.auth.redirectUrl, "msmloop.com"))
        return googleApiKeys.msm;
      if (_.includes(process.auth.redirectUrl, "audi-mysteryshopping"))
        return googleApiKeys.audi;
      return googleApiKeys.dev;
    },
  },
  methods: {
    localizeFlatpickrConfig() {
      this.flatpickrDateConfig.locale = this.currentLocale;
      this.flatpickrIsoDateConfig.locale = this.currentLocale;
      this.flatpickrDatetimeConfig.locale = this.currentLocale;

      let dateFormat;
      switch (this.currentLocale) {
        case "de":
          dateFormat = "d.m.Y";
          break;
        case "fr":
        case "es":
          dateFormat = "d/m/Y";
          break;
        default:
          dateFormat = "Y-m-d";
      }
      this.flatpickrDateConfig.altFormat = dateFormat;
      this.flatpickrIsoDateConfig.altFormat = dateFormat;
      this.flatpickrDatetimeConfig.altFormat = dateFormat + " H:i";
    },
    /**
     * We used to manually toogle open(),but this broke support for mobile and is disabled at the moment
     * @param {String} inputId the Id of the input element
     */
    toggleFlatpickr(inputId) {
      return;
      let el = document.getElementById(inputId);
      if (!el) return;
      let fp = el._flatpickr;
      if (!fp) return;
      fp.toggle();
    },
    /**
     * Show global spinner
     * @param {boolean} immediate
     */
    showSpinner(immediate) {
      if (!this.$debouncedShowSpinnerFunc)
        this.$debouncedShowSpinnerFunc = _.debounce(
          () => (this.spinnerVisible = true),
          500
        );

      if (!this.$stackedSpinnerRequests) this.$stackedSpinnerRequests = 0;
      this.$stackedSpinnerRequests++;

      this.$debouncedShowSpinnerFunc();
      if (immediate) this.$debouncedShowSpinnerFunc.flush();
    },
    hideSpinner() {
      if (--this.$stackedSpinnerRequests > 0) return;

      this.$stackedSpinnerRequests = 0; // Avoid negative values
      this.$debouncedShowSpinnerFunc.cancel();
      this.spinnerVisible = false;
    },
    getCurrencyString(value, currencyCode) {
      if (typeof value === "undefined" || isNaN(value) || value === null)
        return "";
      let result = value.toFixed(2);
      let currency;
      switch (currencyCode) {
        case "EUR":
          currency = {
            symbol: "€",
            prefix: false,
          };
          break;
        case "USD":
          currency = {
            symbol: "$",
            prefix: true,
          };
          break;
        case "CNY":
          currency = {
            symbol: "¥",
            prefix: false,
          };
          break;
        default:
          currency = {
            symbol: "",
            prefix: false,
          };
      }

      switch (this.currentLocale) {
        case "de":
          result = result
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          break;
        default:
          result = result
            .replace(",", ".")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      result = currency.prefix
        ? `${currency.symbol} ${result}`
        : `${result} ${currency.symbol}`;
      return result;
    },
    showSuccessSnackbar(text, timeout) {
      let options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00023;
      options.style = "snackbar-success";
      options.id = "successSnackbar";
      options.onClose = () => {
        $("#successSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#successSnackbar > span").show();
    },
    showErrorSnackbar(text, timeout) {
      let options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar";
      options.onClose = () => {
        $("#errorSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar > span").show();
    },
    async getUrlBlobOfDownload(guid) {
      const res = await UploadService.getFilesbyId(guid, false);
      if (!res.data) {
        throw new Error("No data recieved on download");
      }
      const defaultName = "";
      // we get a noisy string.Clean it!
      const regex = /filename=(.*);/;
      let filename = "";
      if (res.headers["content-disposition"]) {
        const matching = res.headers["content-disposition"].match(regex);
        filename = matching && matching[1] ? matching[1] : "download.xlsx";
      }

      const FILE = window.URL.createObjectURL(new Blob([res.data]));
      return { Blob: FILE, Name: filename };
    },
    async downloadFile(guid) {
      const fileObj = await this.getUrlBlobOfDownload(guid);
      const docUrl = document.createElement("a");
      docUrl.href = fileObj.Blob;
      docUrl.setAttribute("download", fileObj.Name);
      document.body.appendChild(docUrl);
      docUrl.click();
      docUrl.remove();
    },
    /**
     * Downloads a file and names it
     * @param {String} guid The download guid
     * @param {String} filename The file name
     */
    async downloadFilewithName(guid, filename) {
      const res = await UploadService.getFilesbyId(guid, false);
      if (!res.data) {
        throw new Error("No data recieved on download");
      }

      const FILE = window.URL.createObjectURL(new Blob([res.data]));
      const docUrl = document.createElement("a");
      docUrl.href = FILE;
      docUrl.setAttribute("download", filename);
      document.body.appendChild(docUrl);
      docUrl.click();
      docUrl.remove();
    },
    /**
     * Compress file using https://www.npmjs.com/package/compress.js
     * File type does not get changed, but file get resized
     * @param {Blob} file
     * @param {number} size the max size in MB
     */
    compressFile(file, size) {
      return new Promise((resolve, reject) => {
        const compress = new Compress();

        compress
          .compress([file], {
            size: size,
            quality: 0.9,
            maxWidth: 1920,
            maxHeight: 1920,
            resize: true, // default
          })
          .then((results) => {
            const img1 = results[0];
            const base64str = img1.data;
            const imgExt = img1.ext;
            const compressedFile = Compress.convertBase64ToFile(
              base64str,
              imgExt
            );
            compressedFile.name = file.name;
            resolve(compressedFile);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Upload file
     * @param {Blob} file
     * @param {boolean} compress on default no compression
     * @param {callback} success
     * @param {callback} error
     * @param {callback} done
     */
    async uploadFile(file, compress = false, success, error, done) {
      if (compress) {
        file = await this.compressFile(file, 1).catch((err) => {
          console.error("Error while compressing");
          console.error(err);
          this.showErrorSnackbar(this.lang.G00033);
        });
      }
      let uploadData = new FormData();
      uploadData.append("file", file, file.name);
      let uploadGuid = uuidv4();
      this.pendingUploads[uploadGuid] = {};

      this.pendingUploads[uploadGuid].request = $.ajax({
        method: "POST",
        url: "api/Upload",
        data: uploadData,
        dataType: "json",
        contentType: false,
        processData: false,
        global: false,
        xhr: () => {
          let xhr = $.ajaxSettings.xhr();
          if (xhr.upload) {
            this.pendingUploads[uploadGuid].sizes = [0, file.size, 0];

            xhr.upload.addEventListener(
              "progress",
              (e) => {
                if (e.lengthComputable && this.pendingUploads[uploadGuid]) {
                  this.pendingUploads[uploadGuid].sizes = [
                    e.loaded,
                    e.total,
                    e.loaded / e.total,
                  ];
                  this.calculateUploadProgress();
                }
              },
              false
            );
          }
          return xhr;
        },
        success: (data) => {
          if (success) success(data);
        },
        error: (err) => {
          if (err.statusText === "abort") {
            console.error("Upload canceled by user");
            this.globals.showErrorSnackbar(this.lang.G00001);
          } else {
            console.error("Error on POST in uploadFile()");
            this.globals.showErrorSnackbar(this.lang.G00002);
            delete this.pendingUploads[uploadGuid];
          }
          if (error) error();
        },
        complete: () => {
          this.calculateUploadProgress();
          if (done) done();
        },
      });
    },
    /**
     *
     * @param {Array<File>} files -List of Files to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    async uploadFilesv2(files, compress = false) {
      if (compress) {
        const compressedFiles = [];
        for (let file of files) {
          file = await this.compressFile(file, 1).catch((err) => {
            console.error("Error while compressing");
            console.error(err);
            this.showErrorSnackbar(this.lang.G00033);
          });
          compressedFiles.push(file);
        }
        files = compressedFiles;
      }

      const uploadProcesses = [];
      files.map((file) => {
        uploadProcesses.push(UploadService.upload(file));
      });
      return Promise.all(uploadProcesses);
    },
    /**
     *
     * @param {Array<File>} files -List of Files to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @param {boolean} [offline = false] - Are we in offline mode
     * @param {any} [guid = false] - provide an extra guid for indexdb key
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    async uploadFilesv3(
      files,
      compress = false,
      offline = false,
      guid = false
    ) {
      if (compress) {
        const compressedFiles = [];
        for (let file of files) {
          if (!this.isImageType(file)) {
            compressedFiles.push(file);
          } else {
            let blob = await reduceFileSize(file, 500 * 1024, 1920, 1920, 0.9);
            let f = await blobToFile(blob, file);
            compressedFiles.push(f);
          }
        }
        files = compressedFiles;
      }
      let uploadProcesses = [];
      if (offline) {
        uploadProcesses = files.map((file) => {
          let key;
          if (guid) {
            key = [guid, uuidv4()];
          } else {
            key = uuidv4();
          }
          return UploadService.offlineUpload(file, key);
        });
      } else {
        uploadProcesses = files.map((file) => {
          return UploadService.upload(file);
        });
      }
      return Promise.all(uploadProcesses);
    },
    async getFilefromStore(guid) {
      return UploadService.getFilesbyId(guid, true);
    },
    /**
     *
     * @param {Array<String>} guidarray
     * @returns {Promise<Array<String>>}
     */
    async getFilesfromStore(guidarray) {
      const progress = [];
      for (const id of guidarray) {
        progress.push(UploadService.getFilesbyId(id, true));
      }
      return Promise.all(progress);
    },
    calculateUploadProgress() {
      let sumLoaded = 0,
        sumTotal = 0,
        countDone = 0;
      let count = Object.keys(this.pendingUploads).length;

      for (let upload in this.pendingUploads) {
        sumLoaded += this.pendingUploads[upload].sizes[0];
        sumTotal += this.pendingUploads[upload].sizes[1];
        countDone += this.pendingUploads[upload].sizes[2];
      }

      if (count < 1 || countDone == count) {
        this.currentUploadProgress = 100;
        this.pendingUploads = {};
        return;
      }
      this.currentUploadProgress = Number(
        ((sumLoaded * 100) / sumTotal).toFixed(0)
      );
    },
    cancelPendingUploads() {
      this.$nextTick(() => {
        for (let guid in this.pendingUploads) {
          this.pendingUploads[guid].request.abort();
        }
        this.pendingUploads = {};
        this.currentUploadProgress = 100;
      });
    },
    isValidFileType(file, acceptedTypes) {
      if (!acceptedTypes) return true;
      let types = _.split(_.replace(acceptedTypes, / /g, ""), ",");

      for (let type of types) {
        if (
          (type === "image/*" && _.startsWith(file.type, "image/")) ||
          (type === "video/*" && _.startsWith(file.type, "video/")) ||
          (type === "audio/*" && _.startsWith(file.type, "audio/"))
        )
          return true;

        if (file.type === type) return true;

        if (_.startsWith(type, ".") && _.endsWith(file.name, type)) return true;
      }
      return false;
    },
    // Requests the language strings for the selected language from server
    // Requests the language strings for the selected language from server
    getLanguageStrings(that, success, error) {
      if (that.$options.name && this.langCache[that.$options.name]) {
        that.lang = this.langCache[that.$options.name];
        if (success) success();
        return;
      }
      const langKeys = Object.keys(that.lang);

      UseLang.getTranslationfor(that.lang)
        .then(({ data }) => {
          let dataKeys = Object.keys(data);
          if (dataKeys.length == langKeys.length) that.lang = data;
          else {
            for (let i = 0; i < dataKeys.length; i++) {
              that.lang[dataKeys[i]] = data[dataKeys[i]];
            }
          }
          if (that.$options.name)
            this.langCache[that.$options.name] = that.lang;
          if (success) success();
        })
        .catch((err) => {
          if (err.status === 0 || err.status === 401) return; // Request canceled or unauthorized
          console.error(
            "Language data access failed in getLanguageStrings()",
            err
          );
          this.showErrorSnackbar(this.lang.G00003);
          if (error) error(err);
        });
    },
    // Requests information about the current user from backend
    getCurrentUserInfo(callback, errorCallback) {
      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/Current",
        success: (data) => {
          this.currentUserInfo = data;
          this.selectedLanguage = data.FrontendLanguageCode;
          this.$emit("currentUserInfoReceived");
          if (callback) callback();
        },
        error: () => {
          console.error("Userdata access failed in getCurrentUserInfo()");
          this.currentUserInfo = null;
          if (errorCallback) errorCallback();
        },
      });
    },
    isAccessAllowed(policy) {
      if (!policy || !this.currentUserInfo || !this.currentUserInfo.Policies)
        return false;

      let idx = this.currentUserInfo.Policies.indexOf(policy);
      if (idx < 0) return false;
      return true;
    },
    operationPermitted(target) {
      if (!target) return false;
      let targetParts = _.split(target, ".");
      if (targetParts.length < 2) return false;

      let permissionObject = this.permissions[targetParts[0]];
      if (!permissionObject) return false;

      for (let i = 1; i < targetParts.length; i++) {
        if (!permissionObject[targetParts[i]]) return false;
        else permissionObject = permissionObject[targetParts[i]];
      }
      return !!permissionObject;
    },
    // Extracts the date in a localized format from an iso timestamp
    getLocalizedDateFromIsoTimestamp(isoTimestamp) {
      return moment(isoTimestamp).format(this.currentDateFormatForMoment);
    },
    // Extracts the date and time in a localized format from an iso timestamp
    getLocalizedDateTimeFromIsoTimestamp(isoTimestamp) {
      return moment(isoTimestamp).format(this.currentDateTimeFormatForMoment);
    },
    // Extracts the date and time in a localized format from an iso timestamp in UTC
    getLocalizedDateTimeFromUtcIsoTimestamp(isoTimestamp) {
      return moment
        .utc(isoTimestamp)
        .local()
        .format(this.currentDateTimeFormatForMoment);
    },
    getIsoDateFromIsoTimestamp(isoTimestamp) {
      return moment(isoTimestamp).format("YYYY-MM-DD");
    },
    // Requests a list of all countries and returns it by calling the callback function
    getCountryList(callback) {
      if (!_.isEmpty(this.countryList)) {
        if (callback) callback(this.countryList);
        return;
      }

      if (!this.$pendingCountryListCallbacks) {
        this.$pendingCountryListCallbacks = [callback];
      } else {
        this.$pendingCountryListCallbacks.push(callback);
        return;
      }

      let executeCallbacks = (data) => {
        for (let cb of this.$pendingCountryListCallbacks) if (cb) cb(data);
        delete this.$pendingCountryListCallbacks;
      };

      let queryString = `api/Data/Countries`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.countryList = data;
          executeCallbacks(this.countryList);
        },
        error: () => {
          console.error("Error on GET in getCountryList()");
          this.globals.showErrorSnackbar(this.lang.G00004);
          executeCallbacks({});
        },
      });
    },
    getOccupationalGroupList(callback) {
      if (!_.isEmpty(this.occupationalGroupList)) {
        callback(this.occupationalGroupList);
        return;
      }

      let queryString = `api/Data/OccupationalGroup`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.occupationalGroupList = data;
          callback(this.occupationalGroupList);
        },
        error: () => {
          console.error("Error on GET in getOccupationalGroupList()");
          this.globals.showErrorSnackbar(this.lang.G00005);
        },
      });
    },
    getTimezonesList(callback) {
      if (!_.isEmpty(this.timezonesList)) {
        callback(this.timezonesList);
        return;
      }

      let queryString = `api/Data/Timezones`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.timezonesList = data;
          callback(this.timezonesList);
        },
        error: () => {
          console.error("Error on GET in getTimezonesList()");
          this.globals.showErrorSnackbar(this.lang.G00008);
        },
      });
    },
    getRegionsList(callback) {
      if (!_.isEmpty(this.regionsList)) {
        callback(this.regionsList);
        return;
      }

      let queryString = `api/Data/Regions`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.regionsList = data;
          callback(this.regionsList);
        },
        error: () => {
          console.error("Error on GET in getRegionsList()");
          this.globals.showErrorSnackbar(this.lang.G00009);
        },
      });
    },
    getLanguageList(callback) {
      if (!_.isEmpty(this.languageList)) {
        callback(this.languageList);
        return;
      }

      let queryString = `api/Data/Languages`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.languageList = data;
          callback(this.languageList);
        },
        error: () => {
          console.error("Error on GET in getLanguageList()");
          this.globals.showErrorSnackbar(this.lang.G00010);
        },
      });
    },
    getMarketList(callback) {
      if (!_.isEmpty(this.marketList)) {
        callback(this.marketList);
        return;
      }

      let queryString = `api/Data/Markets`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.marketList = data;
          callback(this.marketList);
        },
        error: () => {
          console.error("Error on GET in getMarketList()");
          this.globals.showErrorSnackbar(this.lang.G00034);
        },
      });
    },
    /**
     * Returns a list of clients if still existing else fetch them from backend
     * @returns Promise
     */
    getClientList() {
      if (!_.isEmpty(this.clientList)) {
        return new Promise((resolve, reject) => {
          resolve(this.clientList);
        });
      }

      let queryString = `api/Data/ClientsWithGuid`;
      return new Promise((resolve, reject) => {
        $.ajax({
          method: "GET",
          url: queryString,
          success: (data) => {
            this.clientList = [];
            for (let guid in data) {
              this.clientList.push({
                ClientGuid: guid,
                ClientName: data[guid],
              });
            }
            this.clientList.sort((a, b) => {
              if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase())
                return -1;
              if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase())
                return 1;
              return 0;
            });

            resolve(this.clientList);
          },
          error: () => {
            console.error("Error on GET in getClientList()");
            this.globals.showErrorSnackbar(this.lang.G00011);
            reject([]);
          },
        });
      });
    },
    getImporterList(callback) {
      if (!_.isEmpty(this.importerList)) {
        callback(this.importerList);
        return;
      }

      if (!this.$pendingImporterListCallbacks) {
        this.$pendingImporterListCallbacks = [callback];
      } else {
        this.$pendingImporterListCallbacks.push(callback);
        return;
      }

      let executeCallbacks = (data) => {
        for (let cb of this.$pendingImporterListCallbacks) cb(data);
        delete this.$pendingImporterListCallbacks;
      };

      let queryString = `api/Importer`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.importerList = [];
          if (!_.isEmpty(data)) {
            this.importerList = data;
            let internationalImporter = _.remove(
              this.importerList,
              (importer) =>
                importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA"
            );
            if (internationalImporter[0])
              this.importerList.unshift(internationalImporter[0]);
          }
          executeCallbacks(this.importerList);
        },
        error: () => {
          console.error("Error on GET in getImporterList()");
          this.globals.showErrorSnackbar(this.lang.G00026);
          executeCallbacks([]);
        },
      });
    },
    getCarModelList(callback) {
      if (!_.isEmpty(this.carModelList)) {
        callback(this.carModelList);
        return;
      }

      $.ajax({
        method: "GET",
        url: `api/CarModel`,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.carModelList = [];
          if (!_.isEmpty(data)) this.carModelList = data;
          callback(this.carModelList);
        },
        error: () => {
          console.error("Car model list access failed in getCarModelList()");
          this.globals.showErrorSnackbar(this.lang.G00028);
          callback([]);
        },
      });
    },
    getCarSegmentList(callback) {
      if (!_.isEmpty(this.carSegmentList)) {
        callback(this.carSegmentList);
        return;
      }

      $.ajax({
        method: "GET",
        url: `api/CarModel/CarSegment`,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.carSegmentList = [];
          if (!_.isEmpty(data)) this.carSegmentList = data;
          callback(this.carSegmentList);
        },
        error: () => {
          console.error("Segment list access failed in getCarSegmentList()");
          this.globals.showErrorSnackbar(this.lang.G00029);
          callback([]);
        },
      });
    },
    getClientTypes(callback) {
      if (this.clientTypes[0]) {
        callback(this.clientTypes);
        return;
      }

      let queryString = `api/Data/ClientTypes`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.clientTypes = data;
          callback(this.clientTypes);
        },
        error: () => {
          console.error("Error on GET in getClientTypes()");
          this.globals.showErrorSnackbar(this.lang.G00031);
          callback([]);
        },
      });
    },
    /**
     * NOT WORKING ENDPOINT RETURNS  ""
     * @param {function} callback
     * @returns {string}
     */
    getDepartmentUsers(callback) {
      callback("");

      //return;
      try {
        if (this.departmentUsers[0]) {
          callback(this.departmentUsers);
          return;
        }

        let queryString = `api/Data/DepartmentUsers`;
        $.ajax({
          method: "GET",
          url: queryString,
          success: (data) => {
            this.departmentUsers = data;
            callback(this.departmentUsers);
          },
          error: () => {
            console.error("Error on GET in getDepartmentUsers()");
            this.globals.showErrorSnackbar(this.lang.G00032);
            callback([]);
          },
        });
      } catch (e) {}
    },
    getProjectList(callback) {
      let queryString = `api/Data/Projects`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (_.isEmpty(data)) data = [];
          callback(data);
        },
        error: () => {
          console.error("Error on GET in getProjectList()");
          this.globals.showErrorSnackbar(this.lang.G00012);
          callback([]);
        },
      });
    },
    getWaveList(callback) {
      let queryString = `api/Data/Waves`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data && data[0]) callback(data);
          else callback([]);
        },
        error: () => {
          console.error("Error on GET in getWaveList()");
          this.globals.showErrorSnackbar(this.lang.G00013);
          callback([]);
        },
      });
    },
    getScenarioList(callback) {
      let queryString = `api/Data/Scenarios`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data && data[0]) callback(data);
          else callback([]);
        },
        error: () => {
          console.error("Error on GET in getScenarioList()");
          this.globals.showErrorSnackbar(this.lang.G00014);
          callback([]);
        },
      });
    },
    getAgencyList(callback) {
      let queryString = `api/Data/agencies`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data && data[0]) callback(data);
          else callback([]);
        },
        error: () => {
          console.error("Agency data access failed in getAgencyList()");
          this.globals.showErrorSnackbar(this.lang.G00015);
          callback({});
        },
      });
    },
    getShopperList(callback) {
      let queryString = `api/Data/MysteryShopper`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          callback(data);
        },
        error: () => {
          console.error("Shopper data access failed in getShopperList()");
          this.globals.showErrorSnackbar(this.lang.G00016);
          callback({});
        },
      });
    },
    getUserList(callback) {
      if (!_.isEmpty(this.userList)) {
        callback(this.userList);
        return;
      }

      let queryString = `api/Data/OpUser`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.userList = data;
          callback(data);
        },
        error: () => {
          console.error("User data access failed in getUserList()");
          this.globals.showErrorSnackbar(this.lang.G00030);
          callback({});
        },
      });
    },
    getSettlementStatusses(callback) {
      if (!_.isEmpty(this.settlementStatusses)) {
        callback(this.settlementStatusses);
        return;
      }

      let queryString = `api/Data/SettlementStatusses`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.settlementStatusses = data;
          callback(this.settlementStatusses);
        },
        error: () => {
          console.error("Error on GET in getSettlementStatusses()");
          this.globals.showErrorSnackbar(this.lang.G00007);
        },
      });
    },
    getRoleData(callback) {
      if (this.roleData[0]) {
        callback(this.roleData);
        return;
      }

      if (!this.$pendingRoleDataCallbacks) {
        this.$pendingRoleDataCallbacks = [callback];
      } else {
        this.$pendingRoleDataCallbacks.push(callback);
        return;
      }

      let executeCallbacks = (data) => {
        for (let cb of this.$pendingRoleDataCallbacks) if (cb) cb(data);
        delete this.$pendingRoleDataCallbacks;
      };

      let queryString = `api/Data/RoleTypes`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.roleData = data;
          executeCallbacks(this.roleData);
        },
        error: () => {
          console.error("Error on GET in getRoleData()");
          this.globals.showErrorSnackbar(this.lang.G00017);
          executeCallbacks([]);
        },
      });
    },
    getAgencyTypeList(callback) {
      if (!_.isEmpty(this.agencyTypeList)) {
        callback(this.agencyTypeList);
        return;
      }

      if (!this.$pendingAgencyTypeListCallbacks) {
        this.$pendingAgencyTypeListCallbacks = [callback];
      } else {
        this.$pendingAgencyTypeListCallbacks.push(callback);
        return;
      }

      let executeCallbacks = (data) => {
        for (let cb of this.$pendingAgencyTypeListCallbacks) cb(data);
        delete this.$pendingAgencyTypeListCallbacks;
      };

      let queryString = `api/Data/AgencyTypes`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.agencyTypeList = data;
          executeCallbacks(this.agencyTypeList);
        },
        error: () => {
          console.error("Error on GET in getAgencyTypeList()");
          this.globals.showErrorSnackbar(this.lang.G00027);
          executeCallbacks([]);
        },
      });
    },
    getDistanceUnitList(callback) {
      if (!_.isEmpty(this.distanceUnitList)) {
        callback(this.distanceUnitList);
        return;
      }

      let queryString = `api/Data/DistanceUnits`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.distanceUnitList = data;
          callback(this.distanceUnitList);
        },
        error: () => {
          console.error("Error on GET in getDistanceUnitList()");
          this.globals.showErrorSnackbar(this.lang.G00019);
        },
      });
    },
    getCountryLanguageList(callback) {
      if (!_.isEmpty(this.countryLanguageList)) {
        callback(this.countryLanguageList);
        return;
      }

      let queryString = `api/Data/CountryLanguages`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.countryLanguageList = data;
          callback(this.countryLanguageList);
        },
        error: () => {
          console.error("Error on GET in getCountryLanguageList()");
          this.globals.showErrorSnackbar(this.lang.G00020);
        },
      });
    },
    getLocaleList(callback) {
      if (!_.isEmpty(this.localeList)) {
        callback(this.localeList);
        return;
      }

      let queryString = `api/Data/Locales`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.localeList = data;
          callback(this.localeList);
        },
        error: () => {
          console.error("Error on GET in getLocaleList()");
          this.globals.showErrorSnackbar(this.lang.G00021);
        },
      });
    },
    getPasswordPolicyList(callback) {
      if (!_.isEmpty(this.passwordPolicyList)) {
        callback(this.passwordPolicyList);
        return;
      }

      let queryString = `api/Data/PasswordPolicy`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.passwordPolicyList = data;
          callback(this.passwordPolicyList);
        },
        error: () => {
          console.error("Error on GET in getPasswordPolicyList()");
          this.globals.showErrorSnackbar(this.lang.G00006);
        },
      });
    },
    getSurveyInstancesStatusList(callback) {
      if (!_.isEmpty(this.surveyInstancesStatusList)) {
        callback(this.surveyInstancesStatusList);
        return;
      }

      let queryString = `api/Data/SurveyInstancesStatusses`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.surveyInstancesStatusList = data;
          callback(this.surveyInstancesStatusList);
        },
        error: () => {
          console.error("Error on GET in getSurveyInstancesStatusList()");
          this.globals.showErrorSnackbar(this.lang.G00022);
        },
      });
    },
    // source: https://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
    getImageOrientation(image, callback) {
      if (!image) return;

      let reader = new FileReader();

      reader.onload = (event) => {
        let view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xffd8) return callback(-2);

        let length = view.byteLength,
          offset = 2;

        while (offset < length) {
          let marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            if (view.getUint32((offset += 2), false) != 0x45786966) {
              return callback(-1);
            }
            let little = view.getUint16((offset += 6), false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            let tags = view.getUint16(offset, little);
            offset += 2;

            for (let i = 0; i < tags; i++)
              if (view.getUint16(offset + i * 12, little) == 0x0112)
                return callback(view.getUint16(offset + i * 12 + 8, little));
          } else if ((marker & 0xff00) != 0xff00) break;
          else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(image.slice(0, 64 * 1024));
    },
    resetImageOrientation(srcImage, srcOrientation, callback) {
      if (srcOrientation === 1) {
        callback(srcImage);
        return;
      }

      let img = new Image();

      img.onload = () => {
        let width = img.width,
          height = img.height,
          canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d");

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0);

        let file = this.dataURItoBlob(canvas.toDataURL(srcImage.type));
        file.name = srcImage.name;
        file.lastModifiedDate = new Date();

        // export base64
        callback(file);
      };

      img.src = srcImage.imageUrl;
    },
    //source: https://web.archive.org/web/20160425180542/http://blog.devteaminc.co/posting-a-canvas-image-to-twitter-using-oauth/
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    doAfterNTicks(that, n, f) {
      that.$nextTick(() => {
        if (n < 2) f();
        else this.doAfterNTicks(that, n - 1, f);
      });
    },
    //source: https://stackoverflow.com/questions/16308037/detect-when-elements-within-a-scrollable-div-are-out-of-view
    isNodeVisibleInDOM(elem, container, partial) {
      let contHeight = $(container).height();
      let elemTop = $(elem).offset().top - $(container).offset().top;
      let elemBottom = elemTop + $(elem).height();

      let isTotal = elemTop >= 0 && elemBottom <= contHeight;
      let isPart =
        ((elemTop < 0 && elemBottom > 0) ||
          (elemTop > 0 && elemTop <= contHeight)) &&
        partial;

      return isTotal || isPart;
    },
    truncateString(str, maxLength) {
      if (!str || typeof str !== "string") return "";
      return _.truncate(str, {
        length: maxLength,
        separator: " ",
      });
    },
    getMarkupText(html) {
      if (!html || typeof html !== "string") return "";
      let container = document.createElement("DIV");
      container.innerHTML = html;
      return container.textContent || container.innerText || "";
    },
    isLocalizedDateTodayOrBefore(date) {
      let momentDate = moment(date, this.currentDateFormatForMoment);
      return momentDate.isValid() && this.isISODateTodayOrBefore(momentDate);
    },
    isISODateTodayOrBefore(date) {
      if (!date) return false;
      let momentDate = moment(date);
      if (!momentDate.isValid()) return false;
      let today = moment(new Date());
      return momentDate.isSameOrBefore(today, "day");
    },
    stringEqualsWithoutWildcard(str1, str2) {
      if (typeof str1 !== "string" || typeof str2 !== "string") return false;
      str1 = str1.replace(/%/g, "");
      str2 = str2.replace(/%/g, "");
      if (str1 === str2) return true;
      return false;
    },
    removeWildcardsFromString(str) {
      if (typeof str !== "string") return "";
      return str.replace(/%/g, "");
    },
    addWildcardsToString(str) {
      if (!str || typeof str !== "string") return "";
      return `%${str}%`;
    },
    roleTypeHasSuffix(guid, suffix) {
      if (!guid || !suffix || _.isEmpty(this.roleData)) return false;
      let rt = _.find(this.roleData, (r) => r.RoleTypeGuid === guid);
      if (!rt) {
        console.error("Role type not found");
        return false;
      }
      return _.endsWith(rt.RoleTypeName, suffix);
    },
    getUserRole() {
      if (
        _.isEmpty(this.currentUserInfo) ||
        _.isEmpty(this.currentUserInfo.RoleGuid)
      )
        return false;
      let role = null;
      let roleType = _.find(
        this.roleData,
        (r) =>
          r.RoleTypeGuid.toLowerCase ==
          this.currentUserInfo.RoleTypeGuid.toLowerCase
      );
      if (!roleType) {
        return false;
      } else {
        role = _.find(
          roleType.Roles,
          (r) =>
            r.RoleGuid.toLowerCase == this.currentUserInfo.RoleGuid.toLowerCase
        );
      }
      if (role != null) {
        return role;
      }
      return false;
    },
    doAfterEvents(eventList, task, target = this) {
      let count = eventList.length;
      let execute = () => {
        if (--count > 0) return;
        task();
      };
      for (let event of eventList) {
        target.$once(event, execute);
      }
    },
    insertAtCaret(areaId, text) {
      let area = document.getElementById(areaId);
      let start = area.selectionStart;
      let end = area.selectionEnd;

      $(area).val(
        $(area).val().substring(0, start) + text + $(area).val().substring(end)
      );
      area.selectionStart = area.selectionEnd = start + 1;
    },
  },
  watch: {
    selectedLanguage(newLanguage) {
      if (newLanguage) {
        this.langCache = {};
        this.getLanguageStrings(this);
        this.localizeFlatpickrConfig();
        this.settlementStatusses = {};
        this.countryList = {};
        this.regionsList = [];
        this.occupationalGroupList = {};
        this.roleData = [];
        this.getRoleData();
        this.$emit("languageUpdated");
      }
    },
  },
  data() {
    return {
      currentUserInfo: null,
      selectedLanguage: "",
      spinnerVisible: false,
      tooltipDelay: {
        show: 500,
        hide: 100,
      },
      /**
       * We used to have clickOpens: false,
       * This was to manually call open() ,but it breaks mobile views so we use the default onClick from flatpickr now
       */
      flatpickrDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        defaultDate: [""],
        locale: "en",
      },
      flatpickrIsoDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Z",
        defaultDate: [""],
        locale: "en",
      },
      flatpickrTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: "en",
      },
      flatpickrDatetimeConfig: {
        altInput: true,
        altFormat: "Y-m-d H:i",
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        locale: "en",
      },
      snackbarConfig: {
        content: "", // text of the snackbar
        style: "",
        timeout: 3000,
        htmlAllowed: false,
      },
      countryList: {},
      occupationalGroupList: {},
      timezonesList: [],
      regionsList: [],
      languageList: {},
      marketList: [],
      roleData: [],
      agencyTypeList: [],
      userList: [],
      distanceUnitList: {},
      countryLanguageList: [],
      localeList: [],
      passwordPolicyList: [],
      surveyInstancesStatusList: [],
      settlementStatusses: {},
      clientList: [],
      importerList: [],
      carModelList: [],
      carSegmentList: [],
      clientTypes: [],
      departmentUsers: [],
      pendingUploads: {},
      currentUploadProgress: 100,
      langCache: {},
      lang: {
        G00000: "No results found",
        G00001: "Upload canceled",
        G00002: "Upload failed",
        G00003: "Language data access failed",
        G00004: "Country data request failed",
        G00005: "Occupational group data request failed",
        G00006: "Password policy data request failed",
        G00007: "Invoice status list data request failed",
        G00008: "Timezone data request failed",
        G00009: "Region data request failed",
        G00010: "Language data request failed",
        G00011: "Client data request failed",
        G00012: "Project data request failed",
        G00013: "Wave data request failed",
        G00014: "Scenario data request failed",
        G00015: "Agency data request failed",
        G00016: "Shopper data request failed",
        G00017: "Role data request failed",
        G00018: "Security role data request failed",
        G00019: "Distance unit data request failed",
        G00020: "Country language data request failed",
        G00021: "Locale data request failed",
        G00022: "Check status data request failed",
        G00023: "Success",
        G00024: "Error",
        G00025: "File download failed",
        G00026: "Importer data request failed",
        G00027: "Agency type data request failed",
        G00028: "Car model data request failed",
        G00029: "Car segment data request failed",
        G00030: "User data request failed",
        G00031: "Client type data request failed",
        G00032: "Department users data request failed",
        G00033: "File compression before uploading failed",
        G00034: "Market data request failed",
      },
    };
  },
});

export default globals;



// WEBPACK FOOTER //
// ./src/globals.js